/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earningssold1Inputs */

const en_earningssold1 = /** @type {(inputs: Earningssold1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tickets sold`)
};

const de_earningssold1 = /** @type {(inputs: Earningssold1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkaufte Tickets`)
};

/**
* | output |
* | --- |
* | "Tickets sold" |
*
* @param {Earningssold1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const earningssold1 = /** @type {((inputs?: Earningssold1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earningssold1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earningssold1(inputs)
	return de_earningssold1(inputs)
});
export { earningssold1 as "earningsSold" }